import { request } from '../request';

export async function deleteSingleShiftTemplate(id: string) {
  return request.delete<void>(`/v2/templates/shifts/${id}`);
}
